module.exports = __webpack_public_path__ + "img/weeklyTrend.3e78f238.png";